var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (bindTo, customHint, hasLabels, properties, showButtons, type) {pug_mixins["single-group"] = pug_interp = function(property, type){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["form-group",type + '-property-' + property + '-group'], [false,true]), false, true)+pug.attr("data-property", property, true, true)+pug.attr("data-bind", "visible: " + bindTo(property, "visible") + ", css: { 'has-error': !" + bindTo(property, "isValid()") + " }", true, true)) + "\u003E";
if (hasLabels) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"form-label-container\""+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(["form-input-container",type + "-property-" + property + "-container"], [false,true]), false, true)+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cform\u003E\u003Cdiv class=\"form-inline\"\u003E";
// iterate properties
;(function(){
  var $$obj = properties;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var property = $$obj[pug_index0];
pug_mixins["single-group"](property, type);
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var property = $$obj[pug_index0];
pug_mixins["single-group"](property, type);
    }
  }
}).call(this);

if (customHint) {
pug_html = pug_html + "\u003Cspan class=\"customHint\"\u003E" + (pug.escape(null == (pug_interp = customHint) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if (showButtons) {
pug_html = pug_html + "\u003Cdiv class=\"form-group\"\u003E\u003Cspan class=\"form-input-container\" data-property=\"$buttons\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-inline\"\u003E";
// iterate properties
;(function(){
  var $$obj = properties;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var property = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv" + (" class=\"form-validation-container\""+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var property = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv" + (" class=\"form-validation-container\""+pug.attr("data-property", property, true, true)) + "\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"form-validation-container\" data-property=\"$overall\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";}.call(this,"bindTo" in locals_for_with?locals_for_with.bindTo:typeof bindTo!=="undefined"?bindTo:undefined,"customHint" in locals_for_with?locals_for_with.customHint:typeof customHint!=="undefined"?customHint:undefined,"hasLabels" in locals_for_with?locals_for_with.hasLabels:typeof hasLabels!=="undefined"?hasLabels:undefined,"properties" in locals_for_with?locals_for_with.properties:typeof properties!=="undefined"?properties:undefined,"showButtons" in locals_for_with?locals_for_with.showButtons:typeof showButtons!=="undefined"?showButtons:undefined,"type" in locals_for_with?locals_for_with.type:typeof type!=="undefined"?type:undefined));;return pug_html;};
module.exports = template;